import PatternSwitchEvent from './PatternSwitchEvent.js';
import SubSequenceVolumeChangeEvent from './SubSequenceVolumeChangeEvent.js';
import SequenceRollEvent from './SequenceRollEvent.js';

// event types
export const PATTERN_SWITCH = 1;
export const TRACK_VOLUME_CHANGE = 2;
export const GROUP_VOLUME_CHANGE = 3;
export const SEND_VOLUME_CHANGE = 4;
export const TRACK_MUTE = 5;
export const GROUP_MUTE = 6;
export const PARAMETER_CHANGE = 7;
export const TRACK_SEND_VOLUME_CHANGE = 8;
export const TRACK_SOLO = 9;
export const TRACK_REVERSE = 10;
export const SEQUENCE_ROLL = 11;
export const RESOLUTION_CHANGE = 12;
export const PARAMETER_RAMP = 13;
export const SUB_SEQUENCE_VOLUME_CHANGE = 14;
export const ARRANGEMENT_TRACK_PATTERN = 15;
export const LINEAR_PARAMETER_CHANGE = 16;

export const LINEAR = 'LINEAR';
export const BASIC = 'BASIC';
export const DETERMINISTIC = 'DETERMINISTIC';

export const NO_SUB_SEQUENCE = {
    id: "none"
};

export function constructEvent(type) {
    switch (type) {
    case PATTERN_SWITCH:
        return new PatternSwitchEvent();
    case SEQUENCE_ROLL:
        return new SequenceRollEvent();
    case SUB_SEQUENCE_VOLUME_CHANGE:
        return new SubSequenceVolumeChangeEvent();
    default:
        return undefined;
    }
}

export function isDeterministic(type) {
    switch (type) {
    case SEQUENCE_ROLL:
        return true;
    case RESOLUTION_CHANGE:
        return true;
    case PATTERN_SWITCH:
        return true;
    default:
        return false;
    }
}
